import { render, staticRenderFns } from "./PreviewSettingWatermark.vue?vue&type=template&id=5ff4a5c6&scoped=true&lang=pug"
import script from "./PreviewSettingWatermark.vue?vue&type=script&lang=js"
export * from "./PreviewSettingWatermark.vue?vue&type=script&lang=js"
import style0 from "./PreviewSettingWatermark.vue?vue&type=style&index=0&id=5ff4a5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4a5c6",
  null
  
)

export default component.exports